var path = '/templates/zenclerk_s/directives/dashboard/conversion_chart_widget.html';
var html = "<div class=widget-conversion-chart><div class=\"chart chart-conversion\"><svg></svg></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/conversion_chart_widget.html
// module id = 1335
// module chunks = 0